import { Directive, Input } from '@angular/core';
import { MuiIconFont } from '../../icon';

@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class MuiTabNavItemBase {
  @Input() label?: string;
  @Input() icon?: string;
  @Input() iconFont: MuiIconFont = MuiIconFont.FONTAWESOME;
  @Input() id?: string;
}
